import client from './client';
import { unwrapData } from './response';

export const getTenant = async () => {
  const response = await client.get('/tenant');
  return unwrapData(response, null);
};

export const getBranches = async () => {
  const response = await client.get('/tenant/branches');
  return unwrapData(response);
};

export const getTenantSettings = async () => {
  const response = await client.get('/tenant/settings');
  return unwrapData(response, null);
};

export const getCurrentTenant = async () => {
  const response = await client.get('/tenants/me');
  return unwrapData(response, null);
};

export const CLINIC_CONFIG_TODO = [
  'PATCH /tenant/settings para editar branding, politicas y colores',
  'POST /tenant/branches para crear sucursales',
  'PATCH /tenant/branches/:id para editar horarios, direccion y estado',
  'PATCH /tenant/business para editar datos generales de la clinica'
];
